import {FormGroup} from '@angular/forms';
import { OnInit, Directive } from '@angular/core';
import {Subject} from 'rxjs';

@Directive()
export class AlarmParameterDefaultForm implements OnInit {

    form: FormGroup;
    params: any;
    alarmId: any;
    projectId: any;
    readOnly = false;
    invalidFields: any[] = [];
    paramsChange = new Subject();
    viewIsInited = new Subject();
    submitted = new Subject();

    constructor() {
    }

    ngOnInit() {
        this.mapAlarmParamsToForm();
    }

    // To be overwritten in child classes
    mapAlarmParamsToForm() {
    }

}
